<template>
  <div class="home">
    <editPage @syncData="initData"></editPage>
  </div>
</template>

<style scoped></style>

<script>
import editPage from "../components/editPage.vue"
import "../assets/css/stage_common.css"
export default {
  name: "home",
  components: { editPage },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDownEvent)
  },
  mounted() {
    this.escHandle()
  },
  methods: {
    escHandle() {
      document.addEventListener("keydown", this.keyDownEvent)
    },
    keyDownEvent() {
      let _this = this
      let key = window.event.keyCode
      // esc键   取消克隆模式
      if (key === 27 && _this.$store.state.states.isClonePattern) {
        _this.$store.commit("states/changeGeneralAttr", {
          valName: "isClonePattern",
          val: false
        })
      }
      // esc键   取消排序模式
      if (key === 27 && _this.$store.state.states.isOrderPattern) {
        _this.$store.commit("states/changeGeneralAttr", {
          valName: "isOrderPattern",
          val: false
        })
      }
    },
    initData() {
      // 先判断是否是独立的移动端 并且是都已经同步过
      let data = JSON.parse(JSON.stringify(this.$store.state.appStage))
      if (data.page.isPhoneFullScreen || data.page.isOnlyH5Template) {
        return
      }
      // 不是独立的移动端则需要将pc端的数据 同步到移动端
      data = JSON.parse(JSON.stringify(this.$store.state.stage))
      // if (!data.isPcSyncApp) {
      data.page.isPcSyncApp = true // 做为是否从pc同步过数据的表示
      // }

      if (data.page.subPages) {
        // 只有首页才有subPages
        const subPages = JSON.parse(JSON.stringify(data.page.subPages))
        this.$store.dispatch(this.request_prefix + "/changeSubPageMapping", subPages)
      }

      const isShowHeader = this.$store.state.stage.page.isShowHeader
      const isShowFooter = this.$store.state.stage.page.isShowFooter
      //  把PC端头部和底部的显示状态同步过去
      this.$event.initAppStageEvent()
      this.$store.dispatch("appStage/changeAttribute", { option_name: "isShowHeader", option_val: isShowHeader })
      this.$store.dispatch("appStage/changeAttribute", { option_name: "isShowFooter", option_val: isShowFooter })
      this.$store.dispatch("appStage/initData", { data })
    }
  }
}
</script>
